import moment from 'moment';
import * as Yup from 'yup';

export interface ITraining {
  work_train_id?: string;
  name: string;
  from_date: string;
  to_date: string;
  organization: string;
}

export const trainingInitialValues = {
  work_train_id: '',
  name: '',
  from_date: moment().format('YYYY-MM-DD'),
  to_date: moment().format('YYYY-MM-DD'),
  organization: ''
};

export const TrainingValidationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  from_date: Yup.string().nullable(),
  to_date: Yup.string().nullable(),
  organization: Yup.string().required('Organization is required')
});
